import React, { useState } from 'react';
import './SkillsTabs.css';

const SKILL_TABS = [
  {
    label: 'Data Analytics',
    id: 'analytics',
    skills: [
      'SQL', 'Python', 'R', 'Microsoft Excel', 'Tableau', 'Power BI', 'Matplotlib',
      'Seaborn', 'Scikit-learn', 'TensorFlow', 'PyTorch', 'Pandas', 'NumPy', 'Hadoop', 'Apache Spark',
      'PostgreSQL', 'MySQL', 'MongoDB', 'Google BigQuery', 'Data Wrangling', 'Data Mining',
      'Machine Learning', 'Deep Learning', 'Data Warehousing', 'ETL (Extract, Transform, Load)',
      'Data Visualization', 'Statistics', 'Regression Analysis', 'Hypothesis Testing',
      'Big Data Tools', 'SAS', 'MATLAB', 'Jupyter Notebook', 'Google Analytics', 'Data Modeling',
      'Data Engineering', 'Cloud Platforms (AWS, Azure, Google Cloud)'
    ]
  },
  {
    label: 'Data Science / AI / ML',
    id: 'datascience',
    skills: [
      'Python (NumPy, Pandas, SciPy)', 'Jupyter / Google Colab', 'Scikit-Learn', 'TensorFlow 2.x',
      'PyTorch', 'Hugging Face Transformers', 'LangChain / LlamaIndex (AI apps)', 'OpenAI API / Claude API',
      'Generative AI (Diffusion Models, LLMs, RAG)', 'MLOps (Kubeflow, MLflow)',
      'Data Visualization (Tableau, Power BI, Matplotlib, Plotly)', 'Big Data (Spark, Hadoop)',
      'SQL for Data Science', 'Deep Learning (CNNs, RNNs, Transformers)', 'Cloud AI (AWS Sagemaker, Google Vertex AI, Azure ML)'
    ],
  },
  {
    label: 'DevOps',
    id: 'devops',
    skills: [
      'Linux & Shell Scripting', 'Docker', 'Kubernetes', 'Terraform (IaC)', 'Ansible / Puppet / Chef',
      'Git & GitHub Actions', 'CI/CD (Jenkins, GitLab CI, ArgoCD)',
      'AWS (EC2, S3, Lambda, EKS, CloudFormation)', 'Google Cloud Platform (GKE, BigQuery, Cloud Run)',
      'Microsoft Azure (AKS, Functions, Logic Apps)', 'Cloudflare Workers',
      'Monitoring (Prometheus, Grafana, Datadog, New Relic)', 'Security (DevSecOps, OWASP, Vault)'
    ],
  },
  {
    label: 'Frontend Development',
    id: 'frontend',
    skills: [
      'HTML5', 'CSS3 (Flexbox, Grid)', 'JavaScript (ES6+)', 'TypeScript', 'ReactJS', 'Next.js',
      'Angular', 'Vue.js', 'Svelte', 'SolidJS', 'Tailwind CSS', 'Bootstrap',
      'Material UI', 'WebAssembly', 'Redux Toolkit / Zustand', 'Vite'
    ],
  },
  {
    label: 'Backend Development',
    id: 'backend',
    skills: [
      'Node.js', 'Express.js', 'NestJS', 'Spring Boot (Java)', 'Django (Python)',
      'Flask (Python)', 'FastAPI', 'Ruby on Rails', 'ASP.NET Core',
      'Golang (Gin, Fiber)', 'Kotlin (Ktor)', 'PHP (Laravel, Symfony)', 'GraphQL',
      'REST API', 'gRPC', 'Serverless (AWS Lambda, Azure Functions)'
    ],
  },
  {
    label: 'Full Stack Development',
    id: 'fullstack',
    skills: [
      'MERN Stack (MongoDB, Express, React, Node.js)', 'MEAN Stack (MongoDB, Express, Angular, Node.js)',
      'JAMstack (JavaScript, APIs, Markup)', 'Next.js + Node.js', 'Nuxt.js + Express',
      'Python Full Stack (Django + React)', 'Java Full Stack (Spring Boot + React/Angular)',
      'T3 Stack (Next.js, tRPC, Tailwind, Prisma)', 'Microservices Architecture', 'Monorepos (NX, Turborepo)'
    ],
  },
  {
    label: 'Quality Assurance',
    id: 'qa',
    skills: [
      'Manual Testing', 'Selenium', 'Cypress', 'Playwright', 'Puppeteer',
      'Jest', 'Mocha / Chai', 'Jasmine', 'Postman / Newman', 'K6 (Load Testing)', 'JMeter',
      'Appium (Mobile Testing)', 'Robot Framework', 'TestCafe', 'Cucumber (BDD)'
    ],
  },
  {
    label: 'AR/VR & Metaverse',
    id: 'arvr',
    skills: [
      'Unity (C#)', 'Unreal Engine (C++ / Blueprints)', 'WebXR / Three.js', 'Blender (3D modeling)',
      'ARKit (Apple)', 'ARCore (Google)', 'Oculus SDK', 'Mixed Reality Toolkit (Microsoft)', 'Spatial Computing APIs'
    ],
  },
  {
    label: 'Mobile App Development',
    id: 'mobile',
    skills: [
      'React Native', 'Flutter (Dart)', 'Swift (iOS)', 'Kotlin (Android)', 'Jetpack Compose',
      'Xamarin / MAUI (Microsoft)', 'Progressive Web Apps (PWA)', 'Capacitor / Ionic',
      'Mobile ML (Core ML, TensorFlow Lite, ONNX Mobile)'
    ],
  }
];

export default function SkillsTabs() {
  const [activeTab, setActiveTab] = useState(SKILL_TABS[0].id);

  return (
    <section className="skills-section">
      <h2 className="skills-title">INTERVIEW ON DEMAND TO TEST 500+ SKILLS</h2>

      <div className="tab-container">
        <div className="tab-buttons">
          {SKILL_TABS.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="tab-content-container">
          {SKILL_TABS.map(tab => (
            <div
              key={tab.id}
              className={`tab-content${activeTab === tab.id ? ' active' : ''}`}
            >
              {activeTab === tab.id && (
                <div className="skills-grid">
                  {tab.skills.map((skill, idx) => (
                    <div key={idx} className="skill-pill">{skill}</div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
